/**
 * The filter a species page's own lists (descriptions, gallery, keys) send
 * to the API: grouped by Catalogue of Life's synonymy on a COL-mode page
 * (/taxon/:id - `colId` given, see ColTaxonGroupResolver), by GBIF's
 * otherwise - same split as the page's own discussion list (filter[taxon]
 * vs filter[species]).
 */
export default function speciesListFilter(gbifId, colId) {
  return colId ? {
    colId
  } : {
    gbifId
  };
}
flarum.reg.add('champis-species', 'forum/utils/speciesListFilter', speciesListFilter);